module.exports = __webpack_public_path__ + "img/saarland.93d2bf6.webp";